import { createTheme } from '@mui/material/styles';
import rtlPlugin from 'stylis-plugin-rtl';
import { prefixer } from 'stylis';

const theme = (direction = 'ltr') => 
  createTheme({
  direction,
  breakpoints: {
    values: {
      xs: 0,
      sm: 650,
      md: 1279,
      lg: 1350,
      xl: 1536,
      '2xl': 1730,
    },
  },
  palette: {
    customColors: {
      primaryText: 'rgba(47, 43, 61, 0.7)',
      secondaryText: '#475467',
      disabledOpacity: 0.5,
    },
  },
  typography: {
    allVariants: {
      color: 'rgba(47, 43, 61, 0.9)',
    },
  },
});
theme.stylisPlugins = [prefixer, rtlPlugin];
export default theme;
